export const SET_ROLE = "setRole";

export const setRole = (payload: any) => {
  return {
    type: SET_ROLE,
    payload,
  };
};
